export enum QuestionState {
    Yes,
    No,
    NotAnswered,
    WithSubQuestions
}

export interface SubQuestion {
    text: string;
    value: QuestionState;
    explanation?: string;
}

export interface Question {
    text: string;
    value: QuestionState;
    subQuestions?: SubQuestion[];
    explanation?: string;
}
